// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".offerBanner__belt{-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);background:#0000004d;border-radius:0 0 var(--radiusNormal) var(--radiusNormal);min-height:48px;padding:8px 16px;position:relative;z-index:1}.button.offerBanner__primaryButton{font-size:14px;line-height:28px;padding:0 6px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
